<template>
  <div class='personPage'>
    <!-- 顶部 Banner -->
    <div class='lb-banner'>
      <div class='lb-banner-inner'>
        <!-- 头像（仅编辑模式可点击上传） -->
        <el-upload
          class='lb-av-uploader'
          action='https://'
          :http-request='(file) => { uploadFile(file) }'
          :show-file-list='false'
          :before-upload='beforeAvatarUpload'
          :disabled='!mode'
          accept='image/*'
        >
          <div class='lb-av' :class='{ "is-readonly": !mode }'>
            <img v-if='imageUrl' :src='imageUrl' class='lb-av-img' />
            <span v-else>{{ avatarText }}</span>
            <div v-if='mode' class='lb-av-badge'>
              <i class='el-icon-camera'></i>
            </div>
          </div>
        </el-upload>

        <!-- 姓名 / 账号 / 邮箱 / 手机 -->
        <div class='lb-head-meta'>
          <div class='lb-name'>{{ dioForm.username || '—' }}</div>
          <div class='lb-account'>
            <span class='code'>@{{ dioForm.account }}</span>
            <span v-if='dioForm.email' class='sep'></span>
            <span v-if='dioForm.email'>{{ dioForm.email }}</span>
            <span v-if='dioForm.mobile' class='sep'></span>
            <span v-if='dioForm.mobile'>{{ dioForm.mobile }}</span>
          </div>
          <div class='lb-pills'>
            <span v-if='customerCode' class='lb-pill lb-pill-code'>
              <i class='el-icon-office-building'></i>{{ customerCode }}
            </span>
            <span v-if='customerBadge' class='lb-pill'>{{ customerBadge }}</span>
          </div>
        </div>

        <!-- 编辑按钮 -->
        <div class='lb-edit-area'>
          <template v-if='!mode'>
            <el-button type='primary' size='small' @click="handleClick('1')">
              <i class='el-icon-edit' style='color: #fff; margin-right: 4px'></i>{{ $t('account_redesign.up_edit_profile') }}
            </el-button>
          </template>
          <template v-else>
            <el-button type='primary' size='small' @click="handleClick('2')">{{ $t('public.save') }}</el-button>
            <el-button size='small' @click="handleClick('3')">{{ $t('public.cancel') }}</el-button>
          </template>
        </div>
      </div>
    </div>

    <!-- 网格区域 -->
    <div class='lb-grid'>
      <!-- 左卡片：基本信息 -->
      <div class='lb-card'>
        <div class='lb-card-head'>
          <div class='lb-card-title'>
            <div class='ic-box'>
              <i class='el-icon-user-solid'></i>
            </div>
            {{ $t('account_redesign.up_basic_info') }}
          </div>
          <span class='lb-card-sub'>4 {{ $t('account_redesign.up_items') }}</span>
        </div>
        <div class='lb-info-body'>
          <el-form
            v-if='mode'
            ref='form'
            :model='dioForm'
            :rules='rules'
            label-width='0'
            class='lb-edit-form'
          >
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-user'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('user.account') }}</div>
                <div class='val'>{{ dioForm.account }}</div>
              </div>
            </div>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-edit-outline'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('labelTitle.display_name') }}</div>
                <el-form-item prop='username' class='lb-form-item'>
                  <el-input v-model='dioForm.username' size='small' style='width: 100%'></el-input>
                </el-form-item>
              </div>
            </div>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-message'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('public.emailbox') }}</div>
                <div class='email-edit-wrap'>
                  <el-input v-model='dioForm.email' size='small' disabled style='width: 100%'></el-input>
                  <el-button
                    v-if='isEnterpriseRoot || isPersonal'
                    type='text'
                    size='small'
                    class='email-change-btn'
                    @click='changeEmailFn'
                  >
                    <i class='el-icon-edit'></i>{{ $t('account_redesign.up_change_email') }}
                  </el-button>
                  <span v-else class='email-readonly-tip'>{{ $t('account_redesign.up_email_readonly') }}</span>
                </div>
              </div>
            </div>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-mobile-phone'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('account_redesign.up_mobile_phone') }}</div>
                <el-form-item prop='mobile' class='lb-form-item'>
                  <el-input v-model='dioForm.mobile' size='small' style='width: 100%'></el-input>
                </el-form-item>
              </div>
            </div>
          </el-form>
          <template v-else>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-user'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('user.account') }}</div>
                <div class='val'>{{ dioForm.account || '—' }}</div>
              </div>
            </div>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-edit-outline'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('labelTitle.display_name') }}</div>
                <div class='val'>{{ dioForm.username || '—' }}</div>
              </div>
            </div>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-message'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('public.emailbox') }}</div>
                <div class='val'>{{ dioForm.email || '—' }}</div>
              </div>
            </div>
            <div class='lb-info-row'>
              <div class='ic'><i class='el-icon-mobile-phone'></i></div>
              <div class='meta'>
                <div class='lbl'>{{ $t('account_redesign.up_mobile_phone') }}</div>
                <div class='val'>{{ dioForm.mobile || '—' }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- 右卡片：功能 -->
      <div class='lb-card'>
        <div class='lb-card-head'>
          <div class='lb-card-title'>
            <div class='ic-box'>
              <i class='el-icon-s-operation'></i>
            </div>
            {{ $t('account_redesign.up_functions') }}
          </div>
          <span class='lb-card-sub'>{{ fnCount }} {{ $t('account_redesign.up_items') }}</span>
        </div>
        <div class='lb-fn-body'>
          <div class='lb-fn-row' data-fn='res' @click="handle('seeSourseFn')">
            <div class='ic-wrap'><i class='el-icon-menu'></i></div>
            <div class='meta'>
              <div class='t'>{{ $t('integration.view_accessible_operation_resources') }}</div>
              <div class='s'>{{ $t('account_redesign.up_res_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
          <div class='lb-fn-row' data-fn='pwd' @click="handle('editPwwdFn')">
            <div class='ic-wrap'><i class='el-icon-lock'></i></div>
            <div class='meta'>
              <div class='t'>{{ $t('integration.change_password') }}</div>
              <div class='s'>{{ $t('account_redesign.up_pwd_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
          <div class='lb-fn-row' data-fn='sig' @click="handle('writeFn')">
            <div class='ic-wrap'><i class='el-icon-edit-outline'></i></div>
            <div class='meta'>
              <div class='t'>
                {{ $t('integration.electronic_signature_') }}
                <span class='fn-status' :class='dataInit.signHad === 1 ? "on" : ""'>
                  {{ dataInit.signHad === 1 ? $t('account_redesign.up_sig_set') : $t('account_redesign.up_sig_not_set') }}
                </span>
              </div>
              <div class='s'>{{ $t('account_redesign.up_sig_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
          <div class='lb-fn-row' data-fn='unit' @click="handle('editUnitSettingFn')">
            <div class='ic-wrap'><i class='el-icon-odometer'></i></div>
            <div class='meta'>
              <div class='t'>{{ $t('integration.unit_setting') }}</div>
              <div class='s'>{{ $t('account_redesign.up_unit_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
          <!-- 定位（企业/个人空间位置） -->
          <div class='lb-fn-row' data-fn='locate' @click="handle('locateFn')">
            <div class='ic-wrap'><i class='el-icon-location-outline'></i></div>
            <div class='meta'>
              <div class='t'>{{ $t('account_redesign.up_locate') }}</div>
              <div class='s'>{{ $t('account_redesign.up_locate_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
          <!-- 申请企业账号（仅个人账号显示） -->
          <div v-if='isPersonal' class='lb-fn-row' data-fn='apply' @click="handle('applyEnterpriseFn')">
            <div class='ic-wrap'><i class='el-icon-office-building'></i></div>
            <div class='meta'>
              <div class='t'>{{ $t('account_redesign.up_apply_enterprise') }}</div>
              <div class='s'>{{ $t('account_redesign.up_apply_enterprise_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
          <!-- 初始账号切换（仅企业初始账号显示） -->
          <div v-if='isEnterpriseRoot' class='lb-fn-row' data-fn='transfer' @click="handle('rootTransferFn')">
            <div class='ic-wrap'><i class='el-icon-switch-button'></i></div>
            <div class='meta'>
              <div class='t'>{{ $t('account_redesign.up_root_transfer') }}</div>
              <div class='s'>{{ $t('account_redesign.up_root_transfer_desc') }}</div>
            </div>
            <i class='el-icon-arrow-right arr'></i>
          </div>
        </div>
      </div>
    </div>

    <RsoureDialog :isShow.sync='isShow' :title='title' :sourseTree='sourseTree'
                  :structureTree='structureTree' />
    <PassWordDialog ref='password' :isShowPass.sync='isShowPass' :title='title' />

    <UnitSettingDialog ref='unitSetting' :isShowUnit.sync='isShowUnit' :title='title' />
    <!-- 电子签名 -->
    <SignatureDialog :signatureShow.sync='signatureShow' :title='title' :imgUrl='imgUrl' />
    <!-- 邮箱修改 -->
    <EmailChangeDialog :isShowEmail.sync='isShowEmail' :title='title' :currentEmail='dioForm.email' />
    <!-- 申请企业账号 -->
    <ApplyEnterpriseDialog :isShowApply.sync='isShowApply' :title='title' :currentEmail='dioForm.email' :currentMobile='dioForm.mobile' />
    <!-- 初始账号切换 -->
    <RootTransferDialog :isShowTransfer.sync='isShowTransfer' :title='title' />
    <!-- 定位（企业/个人空间位置，编辑模式） -->
    <LocateDialog v-if='showLocate' :showLocate.sync='showLocate' :dioForm.sync='locateForm' @save='onSave' />
  </div>
</template>

<script>

import { mineAvatar, mineGuide, mineMe, minePersonal, mineResource, mineUpload } from '@/api/modules/material.js'
import { shareSignature } from '@/api/modules/public.js'
import { customerUpdateLocation } from '@/api/modules/range.js'

import RsoureDialog from './dialog/Rdialog.vue'
import PassWordDialog from './dialog/Password.vue'
import SignatureDialog from './dialog/Signature.vue'
import UnitSettingDialog from './dialog/UnitSetting.vue'
import EmailChangeDialog from './dialog/EmailChangeDialog.vue'
import ApplyEnterpriseDialog from './dialog/ApplyEnterpriseDialog.vue'
import LocateDialog from '@/pages/system/customer/dialog/Locate.vue'
import RootTransferDialog from './dialog/RootTransferDialog.vue'

export default {
  components: {
    RsoureDialog,
    PassWordDialog,
    SignatureDialog,
    UnitSettingDialog,
    EmailChangeDialog,
    ApplyEnterpriseDialog,
    RootTransferDialog,
    LocateDialog
  },
  computed: {
    i18n () {
      return this.$i18n.locale
    },
    accountUserType () {
      return this.$store.getters.accountUserType || localStorage.getItem('userType') || ''
    },
    isEnterpriseRoot () {
      return this.accountUserType === 'ENTERPRISE_ROOT'
    },
    isPersonal () {
      return this.accountUserType === 'PERSONAL'
    },
    customerName () {
      const scope = this.$store.getters.userInfo && this.$store.getters.userInfo.scope
      return (scope && (scope.customer_name || scope.customerName)) || ''
    },
    customerCode () {
      const scope = this.$store.getters.userInfo && this.$store.getters.userInfo.scope
      return (scope && (scope.customer_code || scope.customerCode)) || ''
    },
    // 企业账号显示企业名称，个人账号显示"个人空间"
    customerBadge () {
      if (this.customerName) {
        return this.customerName
      }
      if (this.isPersonal) {
        return this.$t('account_redesign.up_personal_space')
      }
      return ''
    },
    fnCount () {
      let count = 5
      if (this.isPersonal) count++
      if (this.isEnterpriseRoot) count++
      return count
    },
    avatarText () {
      const name = this.dioForm.username || this.dioForm.account || ''
      return name.slice(0, 2).toUpperCase()
    },
    Norules () {
      return {}
    },
    rules () {
      return {
        username: [{
          required: true,
          trigger: 'blur',
          message: this.$t('integration.user_name_cannot_be_empty')
        },
        {
          max: 50,
          trigger: 'blur',
          message: this.$t('integration.length_less_than_50')
        }
        ],
        mobile: [{
          required: true,
          message: this.$t('integration.mobile_number_cannot_be_empty'),
          trigger: 'blur'
        },
        {
          max: 20,
          trigger: 'blur',
          message: this.$t('integration.length_within_20')
        }
        ]
      }
    }
  },
  data () {
    return {
      dataInit: {},
      dioForm: {
        account: '',
        username: '',
        email: '',
        mobile: '',
        gender: 1
      },
      mode: false,
      isShow: false,
      title: '',
      // 资源
      structureTree: [],
      sourseTree: [],
      // 修改密码
      isShowPass: false,
      // 单位设置
      isShowUnit: false,
      // 电子签名
      signatureShow: false,
      imgUrl: '',
      // 邮箱修改
      isShowEmail: false,
      // 申请企业账号
      isShowApply: false,
      // 初始账号切换
      isShowTransfer: false,
      // 定位（企业/个人空间位置）
      showLocate: false,
      locateForm: { address: '', lng: null, lat: null },
      // 当前用户关联的 customerId，用于定位后保存位置
      customerId: null,

      // 补充功能
      imageUrl: ''
    }
  },
  created () {
    this.getInitData()
  },
  methods: {

    getInitData () {
      mineMe().then(({ result }) => {
        this.dataInit = { ...result }
        this.dioForm = { ...result.user }
        // 读取企业/个人空间位置信息
        this.locateForm = {
          address: result.customerAddress || '',
          lng: result.customerLng || null,
          lat: result.customerLat || null
        }
        // 缓存 customerId，用于定位后调用 updateLocation 保存
        this.customerId = result.user && result.user.defaultCustomerId
      })
      mineAvatar().then(({ result }) => {
        this.imageUrl = result && result.avatar || ''
        this.$store.commit('SET_AVATAR', this.imageUrl)
      })
    },
    async justify () {
      // 校验成功则方法自动返回true，校验方法报错则说明校验失败，返回false
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async handleClick (num) {
      if (num === '1' || num === '3') {
        this.mode = !this.mode
        this.clearValidate()
        this.getInitData()
      } else {
        const valid = await this.justify()
        if (!valid) return
        const query = {
          username: this.dioForm.username,
          email: this.dioForm.email,
          mobile: this.dioForm.mobile,
          gender: this.dioForm.gender
        }
        minePersonal(query).then(({ result }) => {
          if (result === 200) {
            this.$message.success(this.$t('public.tip_oper_succ'))
            // 保存成功后切回查看模式并重新拉取数据
            this.mode = false
            this.getInitData()
          } else if (result === 407) {
            this.$message.error(this.$t('integration.user_name_already_exists'))
          } else if (result === 408) {
            this.$message.error(this.$t('integration.email_address_is_required_and_must_conform_to_the_email_format'))
          } else if (result === 409) {
            this.$message.error(this.$t('integration.mobile_number_is_required_and_must_conform_to_the_format_of_mobile_number'))
          } else if (result === 410) {
            this.$message.error(this.$t('integration.mobile_number_already_exists'))
          } else if (result === 411) {
            this.$message.error(this.$t('integration.email_address_already_exists'))
          } else {
            this.$message.error(this.$t('public.tip_oper_fail'))
          }
        })
      }
    },
    handle (method) {
      this[method]()
    },
    /** 引导功能 */
    guideFn () {
      this.$confirm(
        this.$t('integration.are_you_sure_to_turn_boot_on_or_off?'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      ).then(() => {
        const targetGuide = this.dataInit.guideSwitch === 1 ? 0 : 1
        mineGuide({ on: targetGuide }).then(({ result }) => {
          if (result === 200) {
            this.$store.state.userInfo.user.guide_on = targetGuide

            this.$message.success(this.$t('integration.success'))
            this.getInitData()
          } else {
            this.$message.success(this.$t('integration.fail'))
          }
        })
      }).catch(() => {
      })
    },
    /** 资源 */
    seeSourseFn () {
      this.isShow = true
      this.title = this.$t('integration.resources')
      mineResource({ local: this.i18n }).then(({ result }) => {
        // 后端可能返回 null，做守卫避免读取 undefined 报错
        if (!result) {
          this.sourseTree = []
          this.structureTree = []
          return
        }
        this.sourseTree = (result.resource && result.resource.item) || []
        this.structureTree = (result.structure && result.structure.item) || []
      })
    },
    /** 修改密码 */
    editPwwdFn () {
      this.title = this.$t('integration.change_password')
      this.isShowPass = true
      this.$nextTick(() => {
        this.$refs.password.clearValidate()
      })
    },
    /** 单位设置 */
    editUnitSettingFn () {
      this.title = this.$t('integration.unit_setting')
      this.isShowUnit = true
      this.$nextTick(() => {
        if (this.$refs.unitSetting && this.$refs.unitSetting.clearValidate) {
          this.$refs.unitSetting.clearValidate()
        }
      })
    },
    /** 电子签名 */
    writeFn () {
      this.signatureShow = true
      this.title = this.$t('integration.electronic_signature_')
      shareSignature().then(({ result }) => {
        this.imgUrl = result.signature || ''
      })
    },
    /** 邮箱修改（仅企业初始账号） */
    changeEmailFn () {
      this.title = this.$t('account_redesign.up_change_email')
      this.isShowEmail = true
    },
    /** 申请企业账号（仅个人账号） */
    applyEnterpriseFn () {
      this.title = this.$t('account_redesign.up_apply_enterprise_title')
      this.isShowApply = true
    },
    /** 初始账号切换（仅企业初始账号） */
    rootTransferFn () {
      this.title = this.$t('account_redesign.up_root_transfer_title')
      this.isShowTransfer = true
    },
    /** 定位（企业/个人空间位置，编辑模式） */
    locateFn () {
      this.showLocate = true
    },
    /** 定位回调：保存位置到 Customer 表 */
    onSave (form) {
      console.log('[locate] onSave form:', JSON.stringify(form))
      if (!this.customerId) {
        this.$message.error(this.$t('public.tip_oper_fail'))
        return
      }
      const customer = {
        id: this.customerId,
        address: form.address,
        lat: form.lat,
        lng: form.lng
      }
      console.log('[locate] customer to save:', JSON.stringify(customer))
      customerUpdateLocation(customer).then(({ result }) => {
        if (result) {
          this.$message.success(this.$t('public.tip_oper_succ'))
        } else {
          this.$message.error(this.$t('public.tip_oper_fail'))
        }
      }).catch(() => {
        this.$message.error(this.$t('public.tip_oper_fail'))
      })
    },

    // 图片补充功能
    uploadFile (file) {
      this.compressImage(file.file, 156, 156).then(res => {
        this.imageUrl = res
      }).then(() => {
        mineUpload({ avatar: this.imageUrl }).then(({ result }) => {
          if (result === 200) {
            this.$message.success(this.$t('integration.upload_successful'))
            this.$store.commit('SET_AVATAR', this.imageUrl)
          }
        }).catch(() => {
          this.imageUrl = ''
        })
      })
    },
    // 压缩图片：缩放到指定尺寸并转为 webp 格式
    compressImage (file, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            let { width, height } = img
            // 等比缩放
            if (width > maxWidth || height > maxHeight) {
              const ratio = Math.min(maxWidth / width, maxHeight / height)
              width = Math.round(width * ratio)
              height = Math.round(height * ratio)
            }
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)
            // 优先使用 webp，不支持时回退到 jpeg
            const mimeType = canvas.toDataURL('image/webp') ? 'image/webp' : 'image/jpeg'
            const dataUrl = canvas.toDataURL(mimeType, 0.85)
            resolve(dataUrl)
          }
          img.onerror = reject
          img.src = e.target.result
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    // 转64
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        const reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    // 限制上传文件类型以及大小
    beforeAvatarUpload (file) {
      const types = ['image/jpeg', 'image/jpg', 'image/bmp', 'image/png']
      const isImage = types.includes(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error(this.$t('account_redesign.up_avatar_format'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('account_redesign.up_avatar_too_large'))
      }
      return isImage && isLt2M
    }
  }

}
</script>

<style lang='scss' scoped>
.personPage {
  padding: 15px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: auto;

  /* ============ 顶部 Banner ============ */
  .lb-banner {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #e6eaf1;
    box-shadow: 0 4px 14px rgba(20, 30, 55, 0.07);
    overflow: hidden;
    margin-bottom: 16px;

    .lb-banner-inner {
      padding: 22px 26px;
      display: flex;
      align-items: center;
      gap: 20px;
      background:
        radial-gradient(120% 100% at 0% 0%, #eef3fb 0%, transparent 55%),
        radial-gradient(120% 100% at 100% 0%, #f1eef8 0%, transparent 55%),
        linear-gradient(180deg, #fbfcfe, #f4f7fb);
    }
  }

  /* 头像上传 */
  .lb-av-uploader {
    display: inline-block;
    flex-shrink: 0;

    ::v-deep .el-upload {
      display: block;
    }

    /* 非编辑模式下禁用点击 */
    &.is-disabled ::v-deep .el-upload {
      cursor: default;
      pointer-events: none;
    }
  }

  .lb-av {
    width: 78px;
    height: 78px;
    border-radius: 18px;
    border: 3px solid #fff;
    box-shadow: 0 4px 14px rgba(20, 30, 55, 0.12);
    background: linear-gradient(135deg, #cfe0f5, #9fb8d8);
    display: flex;
    align-items: center;
    justify-content: center;
    font: 700 26px 'Sora', sans-serif;
    color: var(--primary-color, #304e72);
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &.is-readonly {
      cursor: default;
    }

    .lb-av-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 15px;
    }

    .lb-av-badge {
      position: absolute;
      right: -3px;
      bottom: -3px;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: #27ae60;
      border: 3px solid #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #fff;
        font-size: 11px;
      }
    }
  }

  /* 姓名 / 账号信息 */
  .lb-head-meta {
    flex: 1;
    min-width: 0;

    .lb-name {
      font: 700 20px 'Sora', sans-serif;
      letter-spacing: -0.01em;
      color: #1f2733;
    }

    .lb-account {
      margin-top: 4px;
      font-size: 12px;
      color: #5b6577;
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;

      .code {
        font-family: 'DM Sans', monospace;
      }

      .sep {
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: #9099ab;
        flex-shrink: 0;
      }
    }

    .lb-pills {
      margin-top: 8px;
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
    }

    .lb-pill {
      padding: 3px 9px;
      border-radius: 6px;
      background: #fff;
      border: 1px solid #e6eaf1;
      font: 600 11px 'DM Sans', sans-serif;
      color: var(--primary-color, #304e72);
      display: inline-flex;
      align-items: center;
      gap: 4px;

      i {
        font-size: 11px;
      }
    }

    .lb-pill-code {
      background: rgba(48, 78, 114, 0.08);
      border-color: rgba(48, 78, 114, 0.15);
    }
  }

  /* 编辑按钮区域 */
  .lb-edit-area {
    flex-shrink: 0;

    .el-button + .el-button {
      margin-left: 8px;
    }
  }

  /* ============ 网格区域 ============ */
  .lb-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .lb-card {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #e6eaf1;
    box-shadow: 0 1px 2px rgba(20, 30, 55, 0.05);
    overflow: hidden;
  }

  .lb-card-head {
    padding: 14px 18px;
    border-bottom: 1px solid #f1f4f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .lb-card-title {
    font: 600 13px 'Sora', sans-serif;
    color: #1f2733;
    display: flex;
    align-items: center;
    gap: 8px;

    .ic-box {
      width: 24px;
      height: 24px;
      border-radius: 7px;
      background: rgba(48, 78, 114, 0.1);
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 13px;
        color: var(--primary-color, #304e72);
      }
    }
  }

  .lb-card-sub {
    font-size: 11px;
    color: #9099ab;
  }

  /* 基本信息 body */
  .lb-info-body {
    padding: 6px 18px 12px;
  }

  .lb-info-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 11px 0;
    border-bottom: 1px solid #f1f4f9;

    &:last-child {
      border-bottom: 0;
    }

    .ic {
      width: 30px;
      height: 30px;
      border-radius: 8px;
      background: #f5f7fb;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i {
        font-size: 14px;
        color: #5b6577;
      }
    }

    .meta {
      flex: 1;
      min-width: 0;
    }

    .lbl {
      font: 600 10px 'DM Sans', sans-serif;
      color: #9099ab;
      letter-spacing: 0.06em;
      text-transform: uppercase;
    }

    .val {
      font: 500 13px 'DM Sans', sans-serif;
      color: #1f2733;
      margin-top: 2px;
      word-break: break-all;
    }

    /* 邮箱编辑区：输入框 + 修改按钮/提示 */
    .email-edit-wrap {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 4px;

      .email-change-btn {
        flex-shrink: 0;
        padding: 0;
        font-size: 12px;
        color: var(--primary-color, #304e72);

        i {
          margin-right: 2px;
        }

        &:hover {
          color: var(--primary-color-hover, #3d6190);
        }
      }

      .email-readonly-tip {
        flex-shrink: 0;
        font-size: 11px;
        color: #c0c4cc;
        white-space: nowrap;
      }
    }
  }

  /* 编辑模式表单 */
  .lb-edit-form {
    .lb-form-item {
      margin-bottom: 0;
      margin-top: 4px;

      ::v-deep .el-form-item__error {
        position: static;
        margin-top: 2px;
      }
    }
  }

  /* 功能 body */
  .lb-fn-body {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .lb-fn-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 12px;
    border-radius: 10px;
    background: #f5f7fb;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
      background: #fff;
      border-color: #e6eaf1;
      box-shadow: 0 1px 2px rgba(20, 30, 55, 0.05);
    }

    .ic-wrap {
      width: 34px;
      height: 34px;
      border-radius: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i {
        font-size: 16px;
        color: #fff;
      }
    }

    .meta {
      flex: 1;
      min-width: 0;
    }

    .t {
      font: 600 13px 'DM Sans', sans-serif;
      color: #1f2733;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .s {
      font-size: 11px;
      color: #9099ab;
      line-height: 1.3;
      margin-top: 2px;
    }

    .arr {
      color: #9099ab;
      flex-shrink: 0;
      font-size: 14px;
    }

    .fn-status {
      font: 600 10px 'DM Sans', sans-serif;
      padding: 2px 7px;
      border-radius: 5px;
      background: #f1f4f9;
      color: #5b6577;

      &.on {
        background: #e6f6ee;
        color: #27ae60;
      }
    }

    &[data-fn='res'] .ic-wrap {
      background: #2d4a7c;
    }

    &[data-fn='pwd'] .ic-wrap {
      background: #d97757;
    }

    &[data-fn='sig'] .ic-wrap {
      background: #7a5af0;
    }

    &[data-fn='unit'] .ic-wrap {
      background: #1f9d8f;
    }

    &[data-fn='locate'] .ic-wrap {
      background: #2d8cf0;
    }

    &[data-fn='apply'] .ic-wrap {
      background: #e6a23c;
    }

    &[data-fn='transfer'] .ic-wrap {
      background: #c0392b;
    }
  }
}

/* 响应式：窄屏单列 */
@media (max-width: 900px) {
  .personPage {
    .lb-grid {
      grid-template-columns: 1fr;
    }

    .lb-banner .lb-banner-inner {
      flex-wrap: wrap;

      .lb-edit-area {
        width: 100%;
        margin-top: 8px;
      }
    }
  }
}
</style>
